var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.videoId,"playerVars":_vm.playerVars},on:{"ready":_vm.onReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }